import { render, staticRenderFns } from "./Mappy.vue?vue&type=template&id=c5f53ef8"
import script from "./Mappy.vue?vue&type=script&lang=js"
export * from "./Mappy.vue?vue&type=script&lang=js"
import style0 from "./Mappy.vue?vue&type=style&index=0&id=c5f53ef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports